import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';
import { V2, XY } from './V2.js';

export interface plls_type {
    id: string;
    type: "plls";
    a: any,
    b: any,
    stiffness: number;
    stiffness_initial: number;
    distance: number;
    distance_initial: number;
    offset: XY;
    pos: XY;
    start_a: XY;
    start_b: XY;
    kill: () => void;
    calc: () => void;
    [key: string]: any;
}

export type plls_manager_type = {
    list: plls_type[];
    get: (id: string) => plls_type | null;
    kill: (id: string) => void;
    make: (io: any) => plls_type;
    run: () => void;
}

export function plls_manager(iterations = 10): plls_manager_type {

    const Plls = {
        list: [] as plls_type[],
        get: function (id: string): plls_type | null {
            return Arry.get.id(this.list, id) as plls_type | null;
        },
        kill: function (id: string): void {
            const link = Arry.get.id(this.list, id);
            if (link) link.kill();
        },
        make: function (io: any): plls_type {
            const l = {
                ...io,
                type: "plls",
                id: io.id || Rndm.id(),
                stiffness: io.stiffness || 0.01,
                stiffness_initial: 0,
                distance: io.distance !== undefined ? io.distance : "auto",
                distance_initial: 0,
                offset: io.offset || { x: 0, y: 0 },
                start_a: { x: 0, y: 0 },
                start_b: { x: 0, y: 0 },
                kill: () => Arry.remove.id(this.list, l.id),
                calc: function (): void {

                    const aTrue = V2.new.set(l.a.pos);
                    const bTrue = V2.new.add(l.b.pos, l.b.dif);
                    V2.add(aTrue, l.offset);

                    const diff = V2.new.sub(aTrue, bTrue);
                    const d = V2.get.length(diff) || 0.001;
                    const difScalar = (l.distance - d) / d * l.stiffness;

                    V2.scale(diff, difScalar);
                    V2.sub(l.b.dif, V2.new.scale(diff, l.a.mass || 1));
                }
            };

            if (l.distance == "auto") l.distance = V2.get.distance(l.a.pos, l.b.pos);
            l.stiffness_initial = l.stiffness;
            l.distance_initial = l.distance;
            V2.set(l.start_a, l.a.pos);
            V2.set(l.start_b, l.b.pos);

            this.list.push(l);
            return l;
        },
        run: function (): void {
            for (let i = 0; i < iterations; i++) {
                for (const l of this.list) l.calc();
            }
        }
    };
    return Plls;
}